"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('draft-js'),
    ContentState = _require.ContentState;

var moment = require('moment');

var htmlToDraft = require('html-to-draftjs')["default"];

var helpers = require('./helpers');

var createDefaultPrintJobs = require('./createDefaultPrintJobs');

var getOrderPrintingOptions = require('./getOrderPrintingOptions');

var _require2 = require('./helpers'),
    removeHTML = _require2.removeHTML;

var PrintJob = require('./PrintJob');

var generateEmailSubject = require('./PrintingDetails/generateEmailSubject');

var generateStaticMarkupReact = require('./generateStaticMarkup');

var generateInventoryReportFunction = require('./generateInventoryReport');

var takeInventory = require('./takeInventory');

var printingCostEstimation = require('./estimatePrintingCost'); // const estimatePrintJobPrintingCostFn = require('./estimatePrintingCost/estimatePrintJobPrintingCost');
// const estimateProductPrintingCostFn = require('./estimatePrintingCost/estimateProductPrintingCost');

/**
 * @module ShinePrinting
 */


function applySettingsToPrintJobPrototype(settings) {
  var REPRINT_REASONS = settings.printJob.reprintReasons;
  var EMAIL_ADDRESSES = settings.printJob.emailAddresses;
  Object.defineProperties(PrintJob.prototype, {
    REPRINT_REASONS: {
      value: REPRINT_REASONS,
      writable: true
    },
    EMAIL_ADDRESSES: {
      value: EMAIL_ADDRESSES,
      writable: true
    }
  });
}

var ShinePrinting = function ShinePrinting() {
  var _instance;

  function init(opts) {
    var options = opts;
    applySettingsToPrintJobPrototype(opts);

    function updateOptions(newOptions) {
      options = newOptions;
      applySettingsToPrintJobPrototype(options);
    } // const printJobs = {
    //     make: function make(params) {
    //         return new PrintJob(params);
    //     },
    // };

    /**
         * defaultPrintJobs
         * the algorithm for creating print jobs
         * @param {Order} order
         * @param {Object} userOpts
         * @returns {Array<PrintJob>}
         */


    function defaultPrintJobs(order, userOpts) {
      return createDefaultPrintJobs(order, userOpts, options.printers);
    }
    /**
         * generateStaticMarkup
         * @param {Order} order
         * @param {PrintJob|Array<PrintJob>} printJobs
         * @param {Shipment|Array<Shipment>} shipments
         * @param {String} senderId - user id of sender
         * @param {String} printerName
         * @param {String} templateName
         */


    function generateStaticMarkup(_ref) {
      var order = _ref.order,
          printJobs = _ref.printJobs,
          _ref$shipments = _ref.shipments,
          shipments = _ref$shipments === void 0 ? {} : _ref$shipments,
          senderId = _ref.senderId,
          printerName = _ref.printerName,
          _ref$templateName = _ref.templateName,
          templateName = _ref$templateName === void 0 ? 'FullOrders' : _ref$templateName;
      var templateNames = {
        printingPlus: ['FullOrders', 'TableNumbers', 'TestPrints', 'ColorChartKits', 'SampleSets', 'CustomSamples'],
        pistachioPress: ['FullOrders', 'SampleSets']
      };
      var printerNames = ['pistachioPress', 'printingPlus'];

      if (!printJobs) {
        throw new Error('printJobs is required');
      }

      if (!shipments) {
        throw new Error('shipments is required');
      }

      if (!printerName) {
        throw new Error('printerName is required');
      }

      if (!printerNames.includes(printerName)) {
        throw new Error("printerName must be one of ".concat(printerNames.join(' | '), ", received ").concat(printerName));
      }

      if (!templateNames[printerName].includes(templateName)) {
        throw new Error("templateName must be one of ".concat(templateNames[printerName].join(' | '), ", received ").concat(templateName));
      }

      var html = generateStaticMarkupReact({
        order: order,
        printJobs: printJobs,
        shipments: shipments,
        senderId: senderId,
        printerName: printerName,
        templateName: templateName,
        options: options
      });
      var blocksFromHtml = htmlToDraft(html);
      var contentBlocks = blocksFromHtml.contentBlocks,
          entityMap = blocksFromHtml.entityMap;
      var draft = ContentState.createFromBlockArray(contentBlocks, entityMap);
      var text = removeHTML(html);
      return {
        text: text,
        draft: draft,
        html: html,
        subject: generateEmailSubject(printJobs, shipments, templateName)
      };
    }

    function reprintReasons() {
      return options.printJob.reprintReasons;
    }

    function getPrintingOptions(order) {
      return getOrderPrintingOptions(order, options.orders.services);
    }

    function generateInventoryReport(inventoryObject, fromDate, toDate, estimatedDigitalPrintingCost, estimatedLetterpressPrintingCost) {
      var html = generateInventoryReportFunction(inventoryObject, fromDate, toDate, estimatedDigitalPrintingCost, estimatedLetterpressPrintingCost);
      var text = removeHTML(html);
      return {
        text: text,
        html: html,
        subject: "Inventory ".concat(moment(fromDate).format('MM/DD/YYYY'), " - ").concat(moment(toDate).format('MM/DD/YYYY'))
      };
    }

    function inventoryDigitalPrintJobs(printJobsArray) {
      if (!Array.isArray(printJobsArray)) {
        throw new Error('inventoryDigitalPrintJobs expects an array');
      }

      return takeInventory(printJobsArray, options).filter(function (_ref2) {
        var category = _ref2.category;
        return !category.match(/letterpress/i);
      });
    }

    function inventoryLetterpressPrintJobs(printJobsArray) {
      if (!Array.isArray(printJobsArray)) {
        throw new Error('inventoryLetterpressPrintJobs expects an array');
      }

      return takeInventory(printJobsArray, options).filter(function (_ref3) {
        var category = _ref3.category;
        return category.match(/letterpress/i);
      });
    }

    function inventoryPrintJobs(printJobsArray) {
      if (!Array.isArray(printJobsArray)) {
        throw new Error('inventoryLetterpressPrintJobs expects an array');
      }

      var digitalPrintJobs = printJobsArray.filter(function (_ref4) {
        var designation = _ref4.designation;
        return !designation.match(/letterpress/i);
      });
      var letterpressPrintJobs = printJobsArray.filter(function (_ref5) {
        var designation = _ref5.designation;
        return designation.match(/letterpress/i);
      });
      return [].concat(_toConsumableArray(inventoryDigitalPrintJobs(digitalPrintJobs)), _toConsumableArray(inventoryLetterpressPrintJobs(letterpressPrintJobs)));
    }
    /**
         * estimatePrintJobPrintingCost
         * @param {PrintJob} printJob
         * @param {String} variant
         */


    function estimatePrintJobPrintingCost(printJob) {
      var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var printerName = printJob.printer_name;
      return printingCostEstimation.estimatePrintJobPrintingCost(printJob, printerName, variant, options);
    }
    /**
         * estimateProductPrintingCost
         * @param {Product} product
         * @param {PrintJob} printJob
         * @param {String} printerName
         * @param {String} variant
         */


    function estimateProductPrintingCost(product) {
      var printJob = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var printerName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'printingPlus';
      var variant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      return printingCostEstimation.estimateProductPrintingCost(product, printJob, printerName, variant, options);
    }

    return _objectSpread({
      estimatePrintJobPrintingCost: estimatePrintJobPrintingCost,
      estimateProductPrintingCost: estimateProductPrintingCost,
      inventoryPrintJobs: inventoryPrintJobs,
      inventoryDigitalPrintJobs: inventoryDigitalPrintJobs,
      inventoryLetterpressPrintJobs: inventoryLetterpressPrintJobs,
      updateOptions: updateOptions,
      options: options,
      printJobs: {
        make: function make(params) {
          return new PrintJob(params);
        }
      },
      reprintReasons: reprintReasons,
      defaultPrintJobs: defaultPrintJobs,
      getPrintingOptions: getPrintingOptions,
      generateStaticMarkup: generateStaticMarkup,
      generateInventoryReport: generateInventoryReport
    }, helpers);
  }

  return {
    /**
         * initialize
         * @param {*} opts
         * @instance
         * @example
         * import { ShinePrinting } from 'shine-products-v2';
         * ShinePrinting.initialize(opts);
         */
    initialize: function initialize(opts) {
      _instance = init(opts);
    },

    /**
         * SINGLETON INSTANCE
         * @instance
         * @example
         * import { ShinePrinting } from 'shine-products-v2';
         * ShinePrinting.instance()
         */
    instance: function instance() {
      if (!_instance) {
        throw new Error('You must first initialize');
      }

      return _instance;
    }
  };
}();

module.exports = ShinePrinting;